import React from "react";
import { toast } from "react-toastify";
import moment from "moment-timezone";
import { playNotificationSound } from "./sound";

export function ToastError(message) {
  toast.error(message, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
}

export function ToastConfirmedTrip() {
  toast.success("Confirmed Successfully!", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
}

export function ToastMarkedCancelledTrip() {
  toast.warn("Cancelled Successfully!", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
}

export function ToastWillCallActivated() {
  toast.success("Will Call Activated!", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
}

export function ToastSuggestedTimeUpdated() {
  toast.success("Suggested Time Updated!", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
}

export function ToastUnconfirmedTrip() {
  toast.success("Marked as Not Authorized!", {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
}

/**
 * Toast notification for general socket notifications
 */
export function ToastGeneralNotification(data) {
  if (!data) return;

  playNotificationSound();

  const title =
    typeof data === "string" ? "Notification" : data.title || "Trip Notification";
  const message =
    typeof data === "string"
      ? data
      : data.message || data.body || JSON.stringify(data);
  const type =
    data.type === "error" || data.type === "warn" || data.type === "success"
      ? data.type
      : "info";
  const toastFn = toast[type] || toast.info;

  toastFn(
    <div className="flex flex-col space-y-1 py-0.5">
      <div className="font-bold text-sm tracking-tight">{title}</div>
      <div className="text-xs opacity-90 leading-snug">{message}</div>
    </div>,
    {
      position: "top-right",
      autoClose: 6000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    }
  );
}

/**
 * Rich Toast notification for real-time memberLinkNotification events
 */
export function ToastMemberLinkNotification(payload, options = {}) {
  if (!payload) return;

  playNotificationSound();

  const tripId = payload.tripId || payload.memberAssign || "Trip Request";
  const actionRaw = payload.action || "received";
  const actionUpper = actionRaw.toUpperCase();
  const message = payload.message;
  const intakeStatus = payload.intakeStatus
    ? payload.intakeStatus.replace(/_/g, " ").toUpperCase()
    : null;
  const scheduleTime = payload.scheduleTime
    ? moment(payload.scheduleTime).format("MMM DD, YYYY • hh:mm A")
    : null;

  const act = actionRaw.toLowerCase();
  let toastFn = toast.info;
  if (act.includes("cancel") || act.includes("reject")) {
    toastFn = toast.error;
  } else if (
    act.includes("confirm") ||
    act.includes("accept") ||
    act.includes("complete")
  ) {
    toastFn = toast.success;
  } else if (
    act.includes("receive") ||
    act.includes("intake") ||
    act.includes("create")
  ) {
    toastFn = toast.info;
  }

  toastFn(
    <div className="flex flex-col space-y-1.5 text-white py-0.5">
      {/* Header: Action badge & Trip ID */}
      <div className="flex items-center gap-2">
        <span className="bg-black/25 px-2 py-0.5 rounded-md text-[10px] font-extrabold tracking-wider uppercase ring-1 ring-white/30">
          {actionUpper}
        </span>
        <span className="font-mono font-bold text-sm tracking-tight truncate">
          {tripId}
        </span>
      </div>

      {/* Message Body */}
      {message ? (
        <div className="text-xs font-normal leading-relaxed opacity-95">
          {message}
        </div>
      ) : (
        <div className="space-y-0.5">
          {intakeStatus && (
            <div className="text-xs font-medium opacity-95 flex items-center gap-1">
              <span className="opacity-75">Status:</span>
              <span className="font-semibold">{intakeStatus}</span>
            </div>
          )}
          {scheduleTime && (
            <div className="text-[11px] opacity-85">
              Scheduled: {scheduleTime}
            </div>
          )}
        </div>
      )}
    </div>,
    {
      position: "top-right",
      autoClose: options.autoClose !== undefined ? options.autoClose : 7000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
      ...options,
    }
  );
}
